import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from 'src/app/state/action-sources';
import { BlueSageSetupFragment } from 'src/generated/graphql.generated';

export const BlueSageSettingsActions = createActionGroup({
    source: ActionSource.BLUESAGE_SETTINGS,
    events: {
        'Panel Opened': emptyProps(),
        'Refresh Button Clicked': emptyProps(),
        'Load Setup Success': props<{ status: BlueSageSetupFragment }>(),
        'Load Setup Error': props<{ error: Error }>(),

        'Api Key Changed': props<{ apiKey: string }>(),
        'Webhook Signing Secret Changed': props<{ webhookSigningSecret: string }>(),
        'Save Credentials Button Clicked': emptyProps(),
        'Save Credentials Success': props<{ status: BlueSageSetupFragment }>(),
        'Save Credentials Error': props<{ error: Error }>(),

        'Location Id Changed': props<{ locationId: string }>(),
        'Save Location Button Clicked': emptyProps(),
        'Save Location Success': props<{ status: BlueSageSetupFragment }>(),
        'Save Location Error': props<{ error: Error }>(),

        'Payment Type Switch Toggled': props<{ enabled: boolean }>(),
        'Set Enabled Success': props<{ status: BlueSageSetupFragment }>(),
        'Set Enabled Error': props<{ error: Error }>(),

        'Holds Switch Toggled': props<{ enabled: boolean }>(),
        'Set Holds Enabled Success': props<{ status: BlueSageSetupFragment }>(),
        'Set Holds Enabled Error': props<{ error: Error }>(),
    },
});
